import axios from "axios";
import { requiredParam } from "@utils/func";

const setAuthHeaders = ({ token = requiredParam("token") } = {}) => {
  axios.defaults.headers["Authorization"] = `Token ${token}`;
};

export { setAuthHeaders };
